import React, { Component } from "react";
import PropTypes from "prop-types";

import LineSeries from "./LineSeries";
import StraightLine from "./StraightLine";
import StaticAreaSeries from "./StaticAreaSeries";
import SVGComponent from "./SVGComponent";

class IntradayMomentumSeries extends Component {
  constructor(props) {
    super(props);
    this.renderClip = this.renderClip.bind(this);
    this.overBoughtClip = this.overBoughtClip.bind(this);
    this.overSoldClip = this.overSoldClip.bind(this);

    const id1 = String(Math.round(Math.random() * 10000 * 10000));
    this.clipPathId1 = `imi-clip-overbought-${id1}`;

    const id2 = String(Math.round(Math.random() * 10000 * 10000));
    this.clipPathId2 = `imi-clip-oversold-${id2}`;
  }

  overBoughtClip(ctx, moreProps) {
    const { chartConfig } = moreProps;
    const { overBought } = this.props;
    const { yScale, width } = chartConfig;

    const overBoughtValue =
      overBought?.value !== undefined ? overBought.value : 70;
    const overBoughtY = yScale(overBoughtValue);

    ctx.beginPath();
    ctx.rect(0, 0, width, overBoughtY);
    ctx.clip();
  }

  overSoldClip(ctx, moreProps) {
    const { chartConfig } = moreProps;
    const { overSold } = this.props;
    const { yScale, width, height } = chartConfig;

    const overSoldValue = overSold?.value !== undefined ? overSold.value : 30;
    const overSoldY = yScale(overSoldValue);

    ctx.beginPath();
    ctx.rect(0, overSoldY, width, height - overSoldY);
    ctx.clip();
  }

  renderClip(moreProps) {
    const { chartConfig } = moreProps;
    const { overBought, overSold } = this.props;
    const { yScale, width, height } = chartConfig;

    const overBoughtValue =
      overBought?.value !== undefined ? overBought.value : 70;
    const overSoldValue = overSold?.value !== undefined ? overSold.value : 30;

    const overBoughtY = yScale(overBoughtValue);
    const overSoldY = yScale(overSoldValue);

    return (
      <defs>
        <clipPath id={this.clipPathId1}>
          <rect x={0} y={0} width={width} height={overBoughtY} />
        </clipPath>
        <clipPath id={this.clipPathId2}>
          <rect x={0} y={overSoldY} width={width} height={height - overSoldY} />
        </clipPath>
      </defs>
    );
  }

  render() {
    const { className, onDoubleClick, onContextMenu, yAccessor } = this.props;
    const { stroke, overBought, overSold } = this.props;
    const { clip } = this.props;

    const overBoughtValue =
      overBought?.value !== undefined ? overBought.value : 70;
    const overSoldValue = overSold?.value !== undefined ? overSold.value : 30;
    const overBoughtColor = overBought?.stroke?.color || "#0000FF";
    const overSoldColor = overSold?.stroke?.color || "#FF0000";

    // Handle stroke for main IMI line
    const imiStroke = stroke?.line ? stroke.line : stroke;

    const style1 = { clipPath: `url(#${this.clipPathId1})` };
    const style2 = { clipPath: `url(#${this.clipPathId2})` };

    return (
      <g className={className}>
        <SVGComponent>{this.renderClip}</SVGComponent>

        {/* Overbought Zone Fill - Fill between IMI line and overbought line */}
        <StaticAreaSeries
          style={style1}
          canvasClip={this.overBoughtClip}
          yAccessor={yAccessor}
          base={(yScale) => yScale(overBoughtValue)}
          fill={overBoughtColor}
          opacity={0.2}
        />

        {/* Oversold Zone Fill - Fill between IMI line and oversold line */}
        <StaticAreaSeries
          style={style2}
          canvasClip={this.overSoldClip}
          yAccessor={yAccessor}
          base={(yScale) => yScale(overSoldValue)}
          fill={overSoldColor}
          opacity={0.2}
        />

        {/* Main IMI Line */}
        <LineSeries
          yAccessor={yAccessor}
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
          stroke={imiStroke}
          clip={clip}
        />

        {/* Overbought Line */}
        <StraightLine
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
          stroke={
            overBought?.stroke || {
              color: "#0000FF",
              dash: "Dash",
              width: 1,
              opacity: 1,
            }
          }
          yValue={overBoughtValue}
        />

        {/* Oversold Line */}
        <StraightLine
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
          stroke={
            overSold?.stroke || {
              color: "#FF0000",
              dash: "Dash",
              width: 1,
              opacity: 1,
            }
          }
          yValue={overSoldValue}
        />
      </g>
    );
  }
}

IntradayMomentumSeries.propTypes = {
  className: PropTypes.string,
  yAccessor: PropTypes.func.isRequired,
  stroke: PropTypes.oneOfType([
    PropTypes.shape({
      color: PropTypes.string,
      dash: PropTypes.string,
      width: PropTypes.number,
      opacity: PropTypes.number,
    }),
    PropTypes.shape({
      line: PropTypes.shape({
        color: PropTypes.string,
        dash: PropTypes.string,
        width: PropTypes.number,
        opacity: PropTypes.number,
      }),
    }),
  ]),
  overBought: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  overSold: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  onDoubleClick: PropTypes.func,
  onContextMenu: PropTypes.func,
  clip: PropTypes.bool,
};

IntradayMomentumSeries.defaultProps = {
  className: "react-stockcharts-imi-series",
  stroke: {
    color: "#00BCD4",
    dash: "Solid",
    width: 1,
    opacity: 1,
  },
  clip: true,
};

export default IntradayMomentumSeries;
